export const meta = {
  id: 'O03', slug: 'status-usuario', title: 'Entenda os status de usuário',
  description: 'Diferencie convite pendente, primeiro acesso, usuário ativo e usuário desabilitado.',
  profile: 'owner', category: 'pessoas', type: 'concept', status: 'published', order: 330,
  keywords: ['status', 'ativo', 'desabilitado', 'convite', 'primeiro acesso'], previous: 'O02', next: 'O04',
  related: ['O01', 'O02'], updatedAt: '2026-08-17', appVersion: 'v1'
}

# Entenda os status de usuário

O status indica a situação operacional do acesso de uma pessoa. Ele não define o que ela pode fazer no sistema.

## Estados que você pode encontrar

- convite ou acesso ainda pendente;
- aguardando primeiro acesso;
- usuário ativo;
- usuário desabilitado.

<HelpImage pendingId="O03.1" alt="Status de usuário na gestão de membros" />

<Callout type="important">Desabilitar um usuário não significa apagar seu histórico. Papel também não deve ser confundido com status.</Callout>
